import { classNames } from "@/react/helpers/twMergeWithCN";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

interface HelpWidgetLayoutProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const HelpWidgetLayout = ({
  children,
  className,
  id,
}: HelpWidgetLayoutProps) => {
  const { isExpanded, sidebarTransitionDuration } = useHelpWidgetContext();
  const isMobile = useSmOrMdScreenMediaQuery();

  const widthTransitionStyle = {
    width: isExpanded ? "736px" : "400px",
    transition: `width ${sidebarTransitionDuration}`,
  };

  return (
    <div
      id={id}
      className={classNames(className || "", {
        "w-[736px]": isExpanded && !isMobile,
        "w-[400px]": !isExpanded && !isMobile,
        "w-full": isMobile,
      })}
      style={isMobile ? undefined : widthTransitionStyle}
    >
      {children}
    </div>
  );
};
